import React, { useState } from "react";
import ProgressIndicator from "../ProgressIndicator";
import { ContributionProps } from "@/types/contributions";
import { WizardStepSkeleton } from "../WizardStepSkeleton";
import { WizardStepError } from "../WizardStepError";

import { useContributionManagement } from "./hooks/useContributionManagement";
import CalculatorModal from "./components/CalculatorModal";
import ContributionIntroduction from "./components/ContributionIntroduction";
import ContributionSteps from "./components/ContributionSteps";
import { useEmployeeContribution } from "./hooks/useEmployeeContribution";

const Contribution: React.FC<ContributionProps> = ({
  handleNext,
  handlePrevious,
  isUserEnrolled,
}) => {
  const [isCalculatorOpen, setIsCalculatorOpen] = useState<boolean>(false);

  const {
    currentContributionStep,
    loading,
    error,
    isSubmitting,
    handleStepNext,
    handleStepPrevious,
  } = useContributionManagement({
    handleNext,
    handlePrevious,
    isUserEnrolled,
  });

  const { employeeInformation } = useEmployeeContribution(isUserEnrolled);

  return (
    <>
      <CalculatorModal
        isOpen={isCalculatorOpen}
        onClose={() => setIsCalculatorOpen(false)}
      />

      <div className="w-full mx-auto font-outfit sm:w-[640px]">
        <ProgressIndicator />

        {!isUserEnrolled && (
          <ContributionIntroduction
            currentContributionStep={currentContributionStep}
            employeeMaxMatch={employeeInformation.EmployerMaxMatch}
            onCalculatorOpen={() => setIsCalculatorOpen(true)}
          />
        )}

        {loading ? (
          <WizardStepSkeleton />
        ) : error ? (
          <WizardStepError
            step={currentContributionStep}
            handlePrevious={handleStepPrevious}
            errorMessage={error}
          />
        ) : (
          <ContributionSteps
            currentStep={currentContributionStep}
            isUserEnrolled={isUserEnrolled}
            onNext={handleStepNext}
            onPrevious={handleStepPrevious}
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </>
  );
};

export default Contribution;
